import { useFormStore } from "components/ProjectSpecificComponents/Contexts/FormStoreContext"
import { observer } from "mobx-react"
import React from "react"
import { TOnClick, TSide } from "../../../../Interfaces/GlobalInterface"
import { TIconKey } from "../Icons/Icon/Interfaces"
import MediumButton from "./MediumButton"

interface Props {
	iconKey?: TIconKey
	iconWidth?: string | number
	iconHeight?: string | number
	iconSide?: TSide
	disabled?: boolean
	onClick?: TOnClick<HTMLButtonElement>
	style?: React.CSSProperties
	children?: React.ReactNode
}

const PreferencesMediumButton = observer(
	({
		iconKey,
		iconWidth,
		iconHeight,
		iconSide,
		disabled,
		onClick,
		style,
		children,
	}: Props) => {
		const formStore = useFormStore()

		return (
			<MediumButton
				className="hide-overflown-text-nowrap"
				style={{
					backgroundColor: formStore.settingsData.personalize.colorButton,
					...style,
				}}
				iconKey={iconKey}
				iconAndTextColor={formStore.settingsData.personalize.colorButtonText ?? "var(--white)"}
				iconWidth={iconWidth}
				iconHeight={iconHeight}
				iconSide={iconSide}
				disabled={disabled}
				onClick={onClick}
				children={children}
			/>
		)
	}
)

export default PreferencesMediumButton
